import cn from 'classnames';

import OPE from 'js/on-page-editing';
import { defineTheme, type ThemeKeys } from 'js/utils/theme-helpers';
import {
  FetchPrioritySelectorMap,
  getEnumStringValue,
  ImageWithCaption_EditorThemeMap
} from 'js/utils/enum-string-maps';

import Image from 'components/image/Image';
import { imageSizes } from 'components/image/image-sizes';

import { IImageWithCaption } from 'source/NFR.types';

const themes = defineTheme({
  noMargin: 'image-with-caption--theme-no-margin'
});
type Theme = ThemeKeys<typeof themes>;

interface ImageWithCaptionProps extends IImageWithCaption {
  className?: string;
  theme?: Theme;
  loading?: 'eager' | 'lazy';
}

const ImageWithCaption: React.FC<ImageWithCaptionProps> = ({
  caption,
  className,
  editorTheme,
  image,
  onPageEditing,
  theme,
  title,
  isExternal,
  fetchPriority
}) => {
  const priority = getEnumStringValue(FetchPrioritySelectorMap, fetchPriority) || undefined;
  return (
    <div
      className={cn(
        'image-with-caption',
        { 'image-with-caption--is-external': isExternal }, // TODO: Remove this class when external images are styled correctly
        themes(theme),
        getEnumStringValue(ImageWithCaption_EditorThemeMap, editorTheme),
        className
      )}
    >
      {title && <h2 {...OPE(onPageEditing?.title)}>{title}</h2>}
      <Image
        {...imageSizes.imageWithCaption}
        {...image}
        {...(isExternal && imageSizes.imageWithCaption.external)}
        fetchPriority={priority}
        loading={priority === 'high' ? 'eager' : 'lazy'}
      />
      <div className="image-with-caption--caption" {...OPE(onPageEditing?.caption)}>
        {caption}
      </div>
    </div>
  );
};

ImageWithCaption.displayName = 'ImageWithCaption';

export default ImageWithCaption;
